import { useEffect, useState } from "react";
import './MoreDetails.scss'
import { fetchSiteMedia, mediaUrl } from '../utils/siteMedia';

export function MoreDetails() {
    const [nutritionalFacts, setNutritionalFacts] = useState('');
    const [qrCode, setQrCode] = useState('');

    useEffect(() => {
        let cancelled = false;
        fetchSiteMedia().then((assets) => {
            if (cancelled) return;
            setNutritionalFacts(mediaUrl(assets, 'product.nutritionalFacts') || '');
            setQrCode(mediaUrl(assets, 'product.qr') || '');
        });
        return () => { cancelled = true; };
    }, []);

    return (
        <div className="More-details-container">
            <div className="productGist">
                <div className="headingContainer">
                    Details
                </div>
                <div className="description">
                    <span>Dates</span>: The Sweet and Nutritious Dry Fruit
                    Dates are a popular dry fruit known for their natural sweetness,
                    chewy texture, and numerous health benefits. They come from the date palm tree,
                    primarily grown in regions like the Middle East, North Africa, and parts of South Asia.
                </div>

                <div className="qualityContainer">
                    Quality
                </div>
                <div className="description">
                    <span>Al Dates</span>: stands for premium quality and authenticity in the world of dates.
                    We are committed to delivering naturally sweet, nutrient-rich dates,
                    ensuring every bite reflects the finest standards of taste and health
                </div>

                <div className="benefitsContainer">
                    Benifits
                </div>
                <div className="benefitsDesign">
                    <div><span></span><div>Heart Health: The potassium content.</div></div>
                    <div><span></span><div>Bone Strength: Calcium.</div></div>
                    <div><span></span><div>Digestive Aid: Fiber helps prevent movements.</div></div>
                    <div><span></span><div>Natural Sweetener: A healthier alternative.</div></div>
                    <div><span></span><div>Heart Health: The potassium content.</div></div>
                    <div><span></span><div>Bone Strength: Calcium.</div></div>
                    <div><span></span><div>Digestive Aid: Fiber helps prevent movements.</div></div>
                    <div><span></span><div>Natural Sweetener: A healthier alternative.</div></div>
                </div>

                {(nutritionalFacts || qrCode) && (
                    <div className="detailsImages">
                        {nutritionalFacts ? <div><img src={nutritionalFacts} alt="nutirtional-facts"/></div> : null}
                        {qrCode ? <div><img src={qrCode} alt="qr-code"/></div> : null}
                    </div>
                )}

            </div>
        </div>
    )
}
